"use strict";
exports.__esModule = true;
exports.agreementsActions = exports.agreementsReducer = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    agreements: { accepted: [], pending: [] },
    initialized: false
};
var agreementsSlice = (0, toolkit_1.createSlice)({
    name: 'agreements',
    initialState: initialState,
    reducers: {
        setAgreements: function (state, action) {
            state.agreements = action.payload.agreements;
            state.initialized = true;
        },
        resetAgreements: function () {
            return initialState;
        }
    }
});
exports.agreementsReducer = agreementsSlice.reducer;
exports.agreementsActions = agreementsSlice.actions;
